// extracted by mini-css-extract-plugin
module.exports = {"ProfileForm":"ProfileForm_ProfileForm__2oQ3j","saveButton":"ProfileForm_saveButton__2Kf7F","profileColContainer":"ProfileForm_profileColContainer__3rNbQ"};